var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclusion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3321 17.2938C28.3321 16.1146 29.2879 15.1586 30.4669 15.1586H33.8652C35.0442 15.1586 36 16.1146 36 17.2938V20.6928C36 21.8721 35.0442 22.8281 33.8652 22.8281H30.4669C29.2879 22.8281 28.3321 21.8721 28.3321 20.6928V17.2938Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33126 21.2509L6.42097 18.9513L16.3394 26.3056L14.2497 28.6051L4.33126 21.2509Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5855 19.0814L31.6752 21.3809L21.7568 28.7352L19.667 26.4356L29.5855 19.0814Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1661 26.2632C14.1661 25.084 15.1218 24.128 16.3009 24.128H19.6991C20.8782 24.128 21.8339 25.084 21.8339 26.2632V29.6622C21.8339 30.8415 20.8782 31.7975 19.6991 31.7975H16.3009C15.1218 31.7975 14.1661 30.8415 14.1661 29.6622V26.2632Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.2938C0 16.1146 0.955784 15.1586 2.1348 15.1586H5.53307C6.71209 15.1586 7.66787 16.1146 7.66787 17.2938V20.6928C7.66787 21.8721 6.71209 22.8281 5.53307 22.8281H2.1348C0.955784 22.8281 0 21.8721 0 20.6928V17.2938Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9539 14.6788L22.5239 16.1061C22.263 16.3697 21.8369 16.3697 21.5733 16.1061L17.9998 12.5352L14.429 16.1061C14.1654 16.3697 13.7367 16.3697 13.4757 16.1061L12.0458 14.6788C11.7822 14.4152 11.7822 13.9891 12.0458 13.7255L15.6166 10.1519L12.0458 6.58099C11.7849 6.3147 11.7849 5.88598 12.0458 5.62768L13.4757 4.19772C13.7367 3.93409 14.1654 3.93409 14.429 4.19772L17.9998 7.77129L21.5733 4.19772C21.8369 3.93409 22.2656 3.93409 22.5239 4.19772L23.9539 5.62502C24.2175 5.88864 24.2175 6.31736 23.9565 6.58099L20.383 10.1519L23.9539 13.7255C24.2175 13.9891 24.2175 14.4152 23.9539 14.6788Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusion);
export default __webpack_public_path__ + "static/media/Exclusion.9f25588f21a9907d7cbf2ab0b4bb7ce3.svg";
export { ForwardRef as ReactComponent };